import {SnackbarProvider} from 'notistack';
import {getAppTheme} from 'config/theme.config';
import {CssBaseline, GlobalStyles, ThemeProvider} from '@mui/material';

const ThemeContext = ({children}) => {
  const theme = getAppTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          html: {
            fontSize: '15px', // default is 16px
          },
          caption: {
            fontFamily: 'Inter',
            color: 'light-dark(#000, #fff) !important',
          }, // temporary Fix as Ant is overriding mui color
        }}
      />
      <SnackbarProvider
        maxSnack={10}
        preventDuplicate
        autoHideDuration={3000}
        anchorOrigin={{horizontal: 'center', vertical: 'top'}}>
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  );
};
export default ThemeContext;
